import { env } from '../lib/env';

export function PreviewBanner() {
  if (env.APP_ENV !== 'preview') return null;
  return (
    <div
      role="status"
      data-testid="preview-banner"
      className="fixed bottom-2 left-2 z-[9999] rounded bg-amber-500 px-2 py-1 text-xs font-semibold text-black shadow pointer-events-none"
    >
      Preview environment
    </div>
  );
}
